import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DiscoverCollection } from '@freelancer/datastore/collections';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { FontColor, TextSize } from '@freelancer/ui/text';
import { DiscoverCollectionTypeApi } from 'api-typings/users/users';

@Component({
  selector: 'app-user-list-card',
  template: `
    <fl-icon
      [name]="iconName"
      [color]="iconColor"
      [size]="IconSize.MID"
      [flMarginRight]="Margin.XXSMALL"
    ></fl-icon>

    <fl-bit>
      <fl-bit>
        <ng-container [ngSwitch]="list.type">
          <fl-text
            *ngSwitchCase="DiscoverCollectionTypeApi.LISTS_FAVORITES"
            i18n="Favorites"
            [size]="TextSize.SMALL"
          >
            Favorites
          </fl-text>
          <fl-text
            *ngSwitchCase="DiscoverCollectionTypeApi.LISTS_MY_HIRES"
            i18n="My Hires"
            [size]="TextSize.SMALL"
          >
            My Hires
          </fl-text>
          <fl-text
            *ngSwitchCase="DiscoverCollectionTypeApi.LISTS_MY_CLIENTS"
            i18n="My Clients"
            [size]="TextSize.SMALL"
          >
            My Clients
          </fl-text>
          <fl-text
            *ngSwitchCase="DiscoverCollectionTypeApi.LISTS_CUSTOM"
            [size]="TextSize.SMALL"
          >
            {{ list.name }}
          </fl-text>
        </ng-container>
        <fl-text *ngIf="showItemCount" [color]="FontColor.MID"
          >({{ list.itemCount }})
        </fl-text>
      </fl-bit>
      <app-user-list-details
        *ngIf="showListDetails"
        [collection]="list"
      ></app-user-list-details>
    </fl-bit>

    <app-user-list-more-actions
      *ngIf="showMoreOptions"
      class="CollectionMoreActions"
      [userList]="list"
      (click)="disablePropagation($event)"
    ></app-user-list-more-actions>
  `,
  styleUrls: ['./user-list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListCardComponent {
  DiscoverCollectionTypeApi = DiscoverCollectionTypeApi;
  FontColor = FontColor;
  IconSize = IconSize;
  Margin = Margin;
  TextSize = TextSize;

  @Input() list: DiscoverCollection;
  @Input() iconName: string;
  @Input() iconColor: IconColor;
  @Input() showMoreOptions: boolean;
  @Input() showListDetails: boolean;
  @Input() showItemCount: boolean;

  disablePropagation(mouseEvent: MouseEvent) {
    mouseEvent.stopPropagation();
  }
}
